module.exports = __webpack_public_path__ + "client/img/s_item_07.e4ed6083.png";